export default __webpack_public_path__ + "img/mobile-arrow-right.3186f95c.svg";